import { render, staticRenderFns } from "./crateDetailPanel.vue?vue&type=template&id=ec24aac6"
import script from "./crateDetailPanel.vue?vue&type=script&lang=js"
export * from "./crateDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./crateDetailPanel.vue?vue&type=style&index=0&id=ec24aac6&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec24aac6')) {
      api.createRecord('ec24aac6', component.options)
    } else {
      api.reload('ec24aac6', component.options)
    }
    module.hot.accept("./crateDetailPanel.vue?vue&type=template&id=ec24aac6", function () {
      api.rerender('ec24aac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/TrackCrates/crateDetailPanel.vue"
export default component.exports